// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h4{
    color:rgb(54, 54, 122);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.workflow_name {
    color: rgb(37, 99, 235);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/css/ModifyWorkflow.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,4DAA4D;AAChE;;AAEA;IACI,uBAAuB;IACvB,4DAA4D;IAC5D,iBAAiB;AACrB","sourcesContent":["h4{\n    color:rgb(54, 54, 122);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.workflow_name {\n    color: rgb(37, 99, 235);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
